/* eslint-disable react/prop-types */
import React from 'react';

import OpenLockIcon from '@/assets/icons/lock-unlocked.svg';
import AdvSetup1 from '@/assets/images/help/AdvSetup1.png';
import AdvSetup2 from '@/assets/images/help/AdvSetup2.png';
import AdvSetup3 from '@/assets/images/help/AdvSetup3.png';
import AdvSetup4 from '@/assets/images/help/AdvSetup4.png';
import AdvSetup5 from '@/assets/images/help/AdvSetup5.png';
import AdvSetup6 from '@/assets/images/help/AdvSetup6.png';
import AdvSetup7 from '@/assets/images/help/AdvSetup7.png';
import AutoProfileBEContinue from '@/assets/images/help/BEContinue.gif';
import AutoProfileBEDiscete from '@/assets/images/help/BEDiscete.gif';
import AutoProfileConcentrate from '@/assets/images/help/Concentrate.gif';
import AutoProfileConcentrateMoreThan50 from '@/assets/images/help/ConcentrateMoreThan50.gif';
import AutoProfileManualControl1 from '@/assets/images/help/ManualControl1.png';
import AutoProfileManualControl2 from '@/assets/images/help/ManualControl2.png';
import AutoProfileRecovery from '@/assets/images/help/Recovery.png';
import AutoProfileStatusAndGraph1 from '@/assets/images/help/StatusAndGraph1.gif';
import AutoProfileStatusAndGraph2 from '@/assets/images/help/StatusAndGraph2.png';
import Button from '@/components/button/Button';
import * as APPDATA from '@/constants/pcConstAppData';

import AutoProfileHelpContent from './AutoProfileHelpContent';
import AutoProfileHelpOption from './AutoProfileHelpOption';

import './AutoProfileHelp.scss';

export function Content(props) {
  const {content} = props;
  return <div className="contentAutoProfileHelp">{content}</div>;
}

export function PageImageContent(props) {
  const {text, image} = props;
  return (
    <div className="row center">
      <div className="col-md-6">{image}</div>
      <div className="col-md-6">{text}</div>
    </div>
  );
}

export const DataHelpHome = [
  {
    Title: 'Auto Profile Options',
    Content: <Content content={<AutoProfileHelpOption />} />,
  },
];

export const DataHelpConcentrate = [
  {
    Title: APPDATA.FIELD_NAME.CONCENTRATE,
    Content: (
      <Content
        content={
          <AutoProfileHelpContent
            content={
              <PageImageContent
                text={
                  <center className="contentText">
                    After you select <b>CONCENTRATE</b>, define the <b>Starting Volume</b> (SV) in mL and{' '}
                    <b>Starting Concentration</b> (SC) in mg/mL based on the sample you’re using, and then type the
                    desired <b>Final Volume</b>. The <b>Estimated Final Concentration</b> will be automatically
                    generated.
                  </center>
                }
                image={
                  <img
                    src={AutoProfileConcentrate}
                    alt={AutoProfileConcentrate}
                  />
                }
              />
            }
          />
        }
      />
    ),
  },
];

export const DataHelpConcentrateMoreThan50 = [
  {
    Title: APPDATA.FIELD_NAME.CONC_TWO_TUBES,
    Content: (
      <Content
        content={
          <AutoProfileHelpContent
            content={
              <PageImageContent
                text={
                  <>
                    <center className="contentText">
                      This option allows you to concentrate a sample of more than 50 mL, which can be split into the
                      sample tube and the buffer tube in equal amounts or in a certain amount as desired.
                    </center>
                    <center className="contentText">
                      <br />
                    </center>
                    <center className="contentText">
                      Define the Starting Volume of both tubes in mL, Starting Concentration in mg/mL based on the
                      sample you’re using, and then define the desired Final Volume. The Estimated Final Concentration
                      will be automatically generated.
                    </center>
                  </>
                }
                image={
                  <img
                    src={AutoProfileConcentrateMoreThan50}
                    alt={AutoProfileConcentrateMoreThan50}
                  />
                }
              />
            }
          />
        }
      />
    ),
  },
];

export const DataHelpBufferDiscrete = [
  {
    Title: `${APPDATA.FIELD_NAME.BUFFER_EXCHANGE} ${APPDATA.FIELD_NAME.DIAFILTRATION_OPTION.DISCRETE}`,
    Content: (
      <Content
        content={
          <AutoProfileHelpContent
            content={
              <PageImageContent
                text={
                  <center className="contentText">
                    Define the sample volume at which buffer exchange will begin in the Sample Volume to Start Exchange
                    (SVTSE) and determine the buffer exchange steps in the Exchange Size field. Then, type the exchange
                    volume to use in the Exchange Volume (EV) field and input the total amount of buffer in the tube
                    into the Current Buffer Volume (CBV) field.
                  </center>
                }
                image={
                  <img
                    src={AutoProfileBEDiscete}
                    alt={AutoProfileBEDiscete}
                  />
                }
              />
            }
          />
        }
      />
    ),
  },
];

export const DataHelpBufferContinuous = [
  {
    // Title: APPDATA.FIELD_NAME.BUFFER_EXCHANGE + " " + APPDATA.FIELD_NAME.DIAFILTRATION_OPTION.CONTINUOUS,
    Title: APPDATA.FIELD_NAME.BUFFER_EXCHANGE,
    Content: (
      <Content
        content={
          <AutoProfileHelpContent
            content={
              <PageImageContent
                text={
                  <>
                    <center className="contentText">
                      1. Define the sample volume at which buffer exchange will begin in the Sample Volume to Start
                      Exchange (SVTSE).
                      <br />
                      2. Define the number of exchange steps in the Step Size.
                      <br />
                      3. Type the Exchange Volume (EV) to use.
                      <br />
                      4. Then, input the Current Buffer Volume (CBV) for the total buffer in tube.
                    </center>
                    <center className="contentText">
                      <br />
                    </center>
                    {/* <center className="contentText">This option allows you to exchange buffer continuously using a step size of 2 mL.</center> */}
                  </>
                }
                image={
                  <img
                    src={AutoProfileBEContinue}
                    alt={AutoProfileBEContinue}
                  />
                }
              />
            }
          />
        }
      />
    ),
  },
];
export const DataHelpAdvancedSetup = [
  {
    Title: APPDATA.FIELD_NAME.ADVANCED_SETUP,
    Content: (
      <Content
        content={
          <AutoProfileHelpContent
            content={
              <PageImageContent
                text={
                  <>
                    <center className="contentText">
                      From the Advanced Setup, you can use the default settings or customize the settings.
                    </center>
                    <center className="contentText">
                      <br />
                    </center>
                    <center className="contentText">
                      Save your changes before running a profile and/or apply them for future use.
                    </center>
                  </>
                }
                image={
                  <img
                    src={AdvSetup1}
                    alt={AdvSetup1}
                  />
                }
              />
            }
          />
        }
      />
    ),
  },
  {
    Title: APPDATA.FIELD_NAME.ADVANCED_SETUP,
    Content: (
      <Content
        content={
          <AutoProfileHelpContent
            content={
              <PageImageContent
                text={
                  <center className="contentText">
                    In the ADVANCED SETUP EXPLORER page, you can load or edit the existing setup. You can also create a
                    new advanced setup by editing the default setup.
                  </center>
                }
                image={
                  <img
                    src={AdvSetup2}
                    alt={AdvSetup2}
                  />
                }
              />
            }
          />
        }
      />
    ),
  },
  {
    Title: APPDATA.FIELD_NAME.ADVANCED_SETUP,
    Content: (
      <Content
        content={
          <AutoProfileHelpContent
            content={
              <PageImageContent
                text={
                  <>
                    <center className="contentText leftBorderGreen">
                      Safety Threshold sets extra volume above the defined Final Volume. After reaching the threshold,
                      the system pauses to allow you to check the volume or proceed to liquid recovery. It applies only
                      to Final Volumes under 3 mL.
                    </center>
                    <center className="contentText">
                      <br />
                    </center>
                    <center className="contentText leftBorderBlue">
                      Prime Chip With determines the liquid to use for priming before running a profile.
                    </center>
                    <center className="contentText">
                      <br />
                    </center>
                    <center className="contentText leftBorderRed">
                      Set the volume to use for priming in the Priming Volume.
                    </center>
                  </>
                }
                image={
                  <img
                    src={AdvSetup3}
                    alt={AdvSetup3}
                  />
                }
              />
            }
          />
        }
      />
    ),
  },
  {
    Title: APPDATA.FIELD_NAME.ADVANCED_SETUP,
    Content: (
      <Content
        content={
          <AutoProfileHelpContent
            content={
              <PageImageContent
                text={
                  <>
                    <center className="contentText leftBorderCyan">
                      When Auto Mixing is set to Off, the Mixing Cycle is set to Manual Mixing which you can do while
                      running an Auto Profile.
                    </center>
                    <center className="contentText">
                      <br />
                    </center>
                    <center className="contentText leftBorderRed">
                      Each time you do a Manual Mixing while running an Auto Profile, the number of Mixing Cycle
                      dictates how many cycles of mixing the Manual Mixing will do.
                    </center>
                  </>
                }
                image={
                  <img
                    src={AdvSetup4}
                    alt={AdvSetup4}
                  />
                }
              />
            }
          />
        }
      />
    ),
  },
  {
    Title: APPDATA.FIELD_NAME.ADVANCED_SETUP,
    Content: (
      <Content
        content={
          <AutoProfileHelpContent
            content={
              <PageImageContent
                text={
                  <center className="contentText leftBorderMagenta">
                    When Auto Mixing is set to On, the Mixing Cycle will be done automatically according to the
                    configuration.
                  </center>
                }
                image={
                  <img
                    src={AdvSetup5}
                    alt={AdvSetup5}
                  />
                }
              />
            }
          />
        }
      />
    ),
  },
  {
    Title: APPDATA.FIELD_NAME.ADVANCED_SETUP,
    Content: (
      <Content
        content={
          <AutoProfileHelpContent
            content={
              <PageImageContent
                text={
                  <>
                    <center className="contentText">
                      Each cycle has its own Cycle Setup which you can configure individually.
                    </center>
                    <center className="contentText">
                      <br />
                    </center>
                    <center className="contentText leftBorderGreen">
                      Diaphragm Pressure is the pressure applied to the diaphragm to make one pulse. A higher pressure
                      enables faster diaphragm timing.
                    </center>
                    <center className="contentText">
                      <br />
                    </center>
                    <center className="contentText leftBorderBlue">
                      Return Valve Pressure is the most important setting to determine the concentration rate and
                      retention. Each cutoff size requires different pressure due to various hole sizes. A higher
                      pressure creates a higher trans-membrane pressure and concentration rate.
                    </center>
                  </>
                }
                image={
                  <img
                    src={AdvSetup6}
                    alt={AdvSetup6}
                  />
                }
              />
            }
          />
        }
      />
    ),
  },
  {
    Title: APPDATA.FIELD_NAME.ADVANCED_SETUP,
    Content: (
      <Content
        content={
          <AutoProfileHelpContent
            content={
              <PageImageContent
                text={
                  <>
                    <center className="contentText leftBorderRed">
                      Diaphragm Fill Time defines how long it takes to fill the diaphragm with fluid in one pumping
                      cycle.
                    </center>
                    <center className="contentText">
                      <br />
                    </center>
                    <center className="contentText leftBorderCyan">
                      Diaphragm Empty Time defines how long it takes a pump to push fluid out of the diaphragm in a
                      single pumping cycle.
                    </center>
                  </>
                }
                image={
                  <img
                    src={AdvSetup7}
                    alt={AdvSetup7}
                  />
                }
              />
            }
          />
        }
      />
    ),
  },
];

export const DataHelpStatusAndGraph = [
  {
    Title: APPDATA.FIELD_NAME.STATUS_AND_GRAPH,
    Content: (
      <Content
        content={
          <AutoProfileHelpContent
            content={
              <PageImageContent
                text={
                  <>
                    <center className="contentText">
                      During profile execution, you can do a real-time observation of the concentration progress in the
                      STATUS tab or check the volume vs. time comparison in the GRAPH tab.
                    </center>
                    <center className="contentText">
                      <br />
                    </center>
                    <center className="contentText">
                      If you want to secure your execution, tap{' '}
                      <Button
                        id="lockIcon"
                        className="lockIcon"
                        icon={OpenLockIcon}
                        iconClassName="lockIconImg"
                        disabled
                      />{' '}
                      & set up a PIN to lock the process. Once it is locked, the execution cannot be paused or stopped
                      until you unlock it using the PIN.
                    </center>
                  </>
                }
                image={
                  <img
                    src={AutoProfileStatusAndGraph1}
                    alt={AutoProfileStatusAndGraph1}
                  />
                }
              />
            }
          />
        }
      />
    ),
  },
  {
    Title: APPDATA.FIELD_NAME.STATUS_AND_GRAPH,
    Content: (
      <Content
        content={
          <AutoProfileHelpContent
            content={
              <PageImageContent
                text={
                  <>
                    <center className="contentText">
                      When you PAUSE the profile execution, the device stops circulating the solution. Tap CONTINUE to
                      resume the execution anytime.
                    </center>
                    <center className="contentText">
                      <br />
                    </center>
                    <center className="contentText">
                      When you STOP the profile execution, the system will provide a Stop Profile Option.
                    </center>
                    <center className="contentText">
                      <br />
                    </center>
                    <center className="contentText">
                      When you tap MANUAL CONTROL it will direct you to do Concentration manually.
                    </center>
                  </>
                }
                image={
                  <img
                    src={AutoProfileStatusAndGraph2}
                    alt={AutoProfileStatusAndGraph2}
                  />
                }
              />
            }
          />
        }
      />
    ),
  },
];

export const DataHelpManualControl = [
  {
    Title: APPDATA.FIELD_NAME.MANUAL_CONTROL,
    Content: (
      <Content
        content={
          <AutoProfileHelpContent
            content={
              <PageImageContent
                text={
                  <center className="contentText">
                    The profile execution will pause when the{' '}
                    <span style={{color: '#FF3372'}}>Current Sample Volume</span> reaches
                    <span style={{color: '#219653'}}> Final Volume</span> +
                    <span style={{color: '#217FED'}}> Safety Threshold</span>. This process prevents over-concentration
                    so that the user can observe the sample volume before reaching the
                    <span style={{color: '#219653'}}> Final Volume</span>. The{' '}
                    <span style={{color: '#217FED'}}>Safety Threshold</span> can be adjusted in the Advanced Setup.
                    <br />
                  </center>
                }
                image={
                  <img
                    src={AutoProfileManualControl1}
                    alt={AutoProfileManualControl1}
                  />
                }
              />
            }
          />
        }
      />
    ),
  },
  {
    Title: APPDATA.FIELD_NAME.MANUAL_CONTROL,
    Content: (
      <Content
        content={
          <AutoProfileHelpContent
            content={
              <PageImageContent
                text={
                  <center className="contentText">
                    Perform additional concentration as needed by selecting{' '}
                    <span style={{color: '#FF3372'}}>Target Volume</span> and then tap CONCENTRATE, or just press the{' '}
                    <span style={{color: '#217FED'}}>Hold to Concentrate</span> and then the system run the Manual
                    Control until the button is released.
                    <br />
                    <br />
                    Tapping the PROCEED TO RECOVERY button will show you the LIQUID RECOVERY and FINISHING options.
                  </center>
                }
                image={
                  <img
                    src={AutoProfileManualControl2}
                    alt={AutoProfileManualControl2}
                  />
                }
              />
            }
          />
        }
      />
    ),
  },
];

export const DataHelpRecovery = [
  {
    Title: APPDATA.FIELD_NAME.RECOVERY_FINISH,
    Content: (
      <Content
        content={
          <AutoProfileHelpContent
            content={
              <PageImageContent
                text={
                  <>
                    <center className="contentText">
                      Once your sample has reached the desired volume, select one of the sample recovery options and
                      define the parameters. Then, you can proceed with the recovery.
                    </center>
                    <center className="contentText">
                      <br />
                    </center>
                    <center className="contentText">
                      You can run the sample recovery multiple times. Tap FINISH when you are done.
                    </center>
                  </>
                }
                image={
                  <img
                    src={AutoProfileRecovery}
                    alt={AutoProfileRecovery}
                  />
                }
              />
            }
          />
        }
      />
    ),
  },
];
